import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/pages.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Convert GL CODE to email for Firebase authentication
      const loginEmail = email.toUpperCase().startsWith('GL') 
        ? `${email.toLowerCase()}@student.gla.local`
        : email;
      
      await login(loginEmail, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const fillDemoStudent = () => {
    setEmail('GL-190');
    setPassword('password');
  };

  const fillDemoInstructor = () => {
    setEmail('instructor@example.com');
    setPassword('instructor');
  };

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', marginBottom: '0.5rem' }}>
            Sign In
          </h1>
          <p style={{ fontSize: '1rem', color: '#666', margin: 0 }}>
            Access your learning dashboard
          </p>
        </div>

        {/* Login Form */}
        <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: '12px', padding: '2rem', marginBottom: '2rem' }}>
          {error && (
            <div style={{
              background: '#ffebee',
              border: '1px solid #ffcdd2',
              color: '#c62828',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1.5rem',
              fontSize: '0.95rem',
              fontWeight: 500
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.5rem', color: '#1a1a1a', fontSize: '0.95rem' }}>
                GL CODE
              </label>
              <input
                type="text"
                placeholder="GL-190"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontFamily: 'inherit',
                  transition: 'all 300ms ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#1a1a1a'}
                onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
              />
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.5rem', color: '#1a1a1a', fontSize: '0.95rem' }}>
                Password
              </label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontFamily: 'inherit',
                  transition: 'all 300ms ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#1a1a1a'}
                onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                background: '#1a1a1a',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 300ms ease',
                opacity: loading ? 0.6 : 1
              }}
              onMouseOver={(e) => !loading && (e.target.style.background = '#333')}
              onMouseOut={(e) => !loading && (e.target.style.background = '#1a1a1a')}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid #e8e8e8' }}>
            <p style={{ fontSize: '0.95rem', color: '#666', margin: 0 }}>
              Welcome to GLA LMS - Your Learning Gateway
            </p>
          </div>
        </div>

        {/* Demo Accounts Section */}
        <div style={{ background: '#1a1a1a', color: 'white', borderRadius: '12px', padding: '2rem', marginBottom: '2rem', display: 'none' }}>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '1rem', margin: '0 0 1rem 0' }}>
            Demo Accounts
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
            {/* Student Demo */}
            <div style={{ background: 'rgba(255, 255, 255, 0.1)', borderRadius: '8px', padding: '1rem', border: '1px solid rgba(255, 255, 255, 0.2)' }}>
              <p style={{ fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>👤 Student</p>
              <p style={{ fontSize: '0.85rem', margin: '0.25rem 0', wordBreak: 'break-all' }}>GL-190</p>
              <p style={{ fontSize: '0.85rem', margin: '0.25rem 0 0.75rem 0' }}>password</p>
              <button
                type="button"
                onClick={fillDemoStudent}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  background: 'white',
                  color: '#1a1a1a',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 300ms ease'
                }}
                onMouseOver={(e) => e.target.style.opacity = '0.9'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
              >
                Fill Student
              </button>
            </div>

            {/* Instructor Demo */}
            <div style={{ background: 'rgba(255, 255, 255, 0.1)', borderRadius: '8px', padding: '1rem', border: '1px solid rgba(255, 255, 255, 0.2)' }}>
              <p style={{ fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>👨‍🏫 Instructor</p>
              <p style={{ fontSize: '0.85rem', margin: '0.25rem 0', wordBreak: 'break-all' }}>instructor@example.com</p>
              <p style={{ fontSize: '0.85rem', margin: '0.25rem 0 0.75rem 0' }}>instructor</p>
              <button
                type="button"
                onClick={fillDemoInstructor}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  background: 'white',
                  color: '#1a1a1a',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 300ms ease'
                }}
                onMouseOver={(e) => e.target.style.opacity = '0.9'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
              >
                Fill Instructor
              </button>
            </div>
          </div>

          {/* Diagnostics Link */}
          <div style={{ textAlign: 'center', paddingTop: '1rem', borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
            <Link to="/diagnostics" style={{ color: 'white', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 500 }}>
              🔧 Run System Diagnostics
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

